const financing = {
    en: {
        "financing.title": "Financing",
        "financing.newRequest": "Request financing",
        "financing.amount": "Amount",
        "financing.vin": "VIN (optional)",
        "financing.note": "Note",
        "financing.submit": "Submit request",
        "financing.myLoans": "My financing",
        "financing.allLoans": "All financing",
        "financing.dealer": "Dealer",
        "financing.status": "Status",
        "financing.date": "Date",
        "financing.actions": "Actions",
        "financing.approve": "Approve",
        "financing.reject": "Reject",
        "financing.pending": "Pending",
        "financing.active": "Active",
        "financing.rejected": "Rejected",
        "financing.paid": "Paid",
        "financing.none": "No financing yet",
        "financing.reviewedBy": "Reviewed by",
        "financing.interestRate": "Interest rate (%)",
        "financing.termMonths": "Term (months)",
        "financing.totalPayable": "Total payable",
        "financing.outstanding": "Outstanding",
        "financing.dueDate": "Due date",
        "financing.approveTitle": "Approve financing",
        "financing.recordPayment": "Record payment",
        "financing.payment": "Payment",
        "financing.payments": "Payments",
        "financing.viewPayments": "Payments",
        "financing.noPayments": "No payments yet",
        "financing.confirm": "Confirm",
        "financing.cancel": "Cancel",
    },
    ru: {
        "financing.title": "Финансирование",
        "financing.newRequest": "Запросить финансирование",
        "financing.amount": "Сумма",
        "financing.vin": "VIN (необязательно)",
        "financing.note": "Примечание",
        "financing.submit": "Отправить запрос",
        "financing.myLoans": "Моё финансирование",
        "financing.allLoans": "Всё финансирование",
        "financing.dealer": "Дилер",
        "financing.status": "Статус",
        "financing.date": "Дата",
        "financing.actions": "Действия",
        "financing.approve": "Одобрить",
        "financing.reject": "Отклонить",
        "financing.pending": "В ожидании",
        "financing.active": "Активно",
        "financing.rejected": "Отклонено",
        "financing.paid": "Погашено",
        "financing.none": "Финансирования пока нет",
        "financing.reviewedBy": "Обработал",
        "financing.interestRate": "Ставка (%)",
        "financing.termMonths": "Срок (месяцев)",
        "financing.totalPayable": "К оплате всего",
        "financing.outstanding": "Остаток",
        "financing.dueDate": "Срок погашения",
        "financing.approveTitle": "Одобрить финансирование",
        "financing.recordPayment": "Записать платёж",
        "financing.payment": "Платёж",
        "financing.payments": "Платежи",
        "financing.viewPayments": "Платежи",
        "financing.noPayments": "Платежей пока нет",
        "financing.confirm": "Подтвердить",
        "financing.cancel": "Отмена",
    },
    geo: {
        "financing.title": "დაფინანსება",
        "financing.newRequest": "დაფინანსების მოთხოვნა",
        "financing.amount": "თანხა",
        "financing.vin": "VIN (არასავალდებულო)",
        "financing.note": "შენიშვნა",
        "financing.submit": "მოთხოვნის გაგზავნა",
        "financing.myLoans": "ჩემი დაფინანსება",
        "financing.allLoans": "ყველა დაფინანსება",
        "financing.dealer": "დილერი",
        "financing.status": "სტატუსი",
        "financing.date": "თარიღი",
        "financing.actions": "მოქმედებები",
        "financing.approve": "დამტკიცება",
        "financing.reject": "უარყოფა",
        "financing.pending": "მოლოდინში",
        "financing.active": "აქტიური",
        "financing.rejected": "უარყოფილი",
        "financing.paid": "დაფარული",
        "financing.none": "დაფინანსება ჯერ არ არის",
        "financing.reviewedBy": "დაამუშავა",
        "financing.interestRate": "საპროცენტო განაკვეთი (%)",
        "financing.termMonths": "ვადა (თვე)",
        "financing.totalPayable": "ჯამში გადასახდელი",
        "financing.outstanding": "დარჩენილი",
        "financing.dueDate": "დაფარვის ვადა",
        "financing.approveTitle": "დაფინანსების დამტკიცება",
        "financing.recordPayment": "გადახდის დაფიქსირება",
        "financing.payment": "გადახდა",
        "financing.payments": "გადახდები",
        "financing.viewPayments": "გადახდები",
        "financing.noPayments": "გადახდები ჯერ არ არის",
        "financing.confirm": "დადასტურება",
        "financing.cancel": "გაუქმება",
    },
};

export default financing;
